// extracted by mini-css-extract-plugin
module.exports = {"block":"_2Ui6W50JhInBCWT4Rk_k6o","modalBlock":"_2_6MtwEz1ODf4RkHY0BTZZ","modalFixed":"_2AvmYZolrBzw7ElqQdLzyf","content":"_382LBRsHbpqL0mZmkmG0Pv","news":"_3XKojFFXgvPDDhHy1nZMqo"};